import { render, staticRenderFns } from "./deep-steps.vue?vue&type=template&id=05bf4f74&scoped=true"
import script from "./deep-steps.vue?vue&type=script&lang=ts"
export * from "./deep-steps.vue?vue&type=script&lang=ts"
import style0 from "./deep-steps.vue?vue&type=style&index=0&id=05bf4f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf4f74",
  null
  
)

export default component.exports